jQuery(document).ready(($) => {
    // General
    const $GeneralScope = {
        // Constructor
        init: function () {
            this.menuScripts();
            this.menuCountries();
            this.openModalSites();
            // this.openModalCookies();
            this.validateCookies();
            this.btnScrollTop();
            this.openExternalLinks();
            this.shareSocialNetworks();
        },

        // Menu scripts
        menuScripts: () => {
            $('a[href="#"]').on("click", (e) => {
                e.preventDefault();
            });

            $(".toogle-menu").on("click", () => {
                $(".menu-principal-container").toggleClass("open-menu-mobile");
            });

            $(".menu-item-has-children").on("click", (e) => {
                let $el = $(e.currentTarget);

                if (!$el.hasClass("open-menu")) {
                    $(".menu-item-has-children").removeClass("open-menu");
                    $el.addClass("open-menu");
                } else {
                    $el.removeClass("open-menu");
                }
            });

            $(document).on("click", (e) => {
                if (
                    !$(".menu-item-has-children a").is(e.target) &&
                    $(".menu-item-has-children").hasClass("open-menu")
                ) {
                    $(".menu-item-has-children").removeClass("open-menu");
                }
            });
        },

        // Menu Countries
        menuCountries: () => {
            $("#menu-paises .menu-item-home").on("click", (e) => {
                e.preventDefault();
                $("#menu-paises").toggleClass("open-menu");
            });

            $(document).click((e) => {
                let country_menu = $(e.target).parent().parent();
                if (!$(country_menu).is("#menu-paises")) {
                    $("#menu-paises").removeClass("open-menu");
                }
            });
        },

        // Modal Sites
        openModalSites: () => {
            $(
                "#menu-menu-top .icon-house a, #menu-menu-top-industria .icon-house a"
            ).on("click", (e) => {
                e.preventDefault();
                $("#swModal").modal("show");
            });
        },

        // Modal Cookies Privacy
        openModalCookies: () => {
            $("#cookieModal").modal("show");
            $("body").removeClass("modal-open");
            $(".modal-backdrop").removeClass("modal-backdrop");
            $GeneralScope.setCookie("SHERWIN_PRIVACY_MODAL_LOADED", 1, 365);

            // Events from modal cookie
            $("#cookieModal .close").click(() => {
                $GeneralScope.setCookie("SHERWIN_PRIVACY_Cookies", 0, 365);
                $GeneralScope.setCookie("SHERWIN_PRIVACY_MODAL_VIEWED", 1, 365);
            });

            $("#cookieModal .modal-body #btn_ok").click(() => {
                $GeneralScope.setCookie("SHERWIN_PRIVACY_Cookies", 1, 365);
                $GeneralScope.setCookie("SHERWIN_PRIVACY_MODAL_VIEWED", 1, 365);
            });
        },

        // Validate Cookies
        validateCookies: () => {
            // Validate Privacy Cookie
            if (!$GeneralScope.getCookie("SHERWIN_PRIVACY_Cookies")) {
                $GeneralScope.openModalCookies();
            }
        },

        // Function to set a cookie
        setCookie: (name, value, expirationDays) => {
            let d = new Date();
            d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },

        // Function to check if a cookie exists
        getCookie: (cookieName) => {
            var name = cookieName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(";");
            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i];
                while (cookie.charAt(0) == " ") {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },

        btnScrollTop: () => {
            $("#up").click(() => {
                console.log("up");
                $("html, body").animate({ scrollTop: 0 }, "slow");
                return false;
            });
        },

        openExternalLinks: () => {
            let compareURL = new RegExp(
                location.host +
                "|" +
                location.host +
                "/#/i|#|sherwin.com.ar|sherwin.com.uy|sherwin.cl|sherwin.com.br|sherwin.com.mx|southerncone.flywheelsites|/wp-content|sherwin-williams.com|tel:|paintdocs.com|luxuriant-shock|/industria|javascript:;" +
                "|swlatamstg.wpenginepowered.com|swlatamprd.wpenginepowered.com|swlatamdev.wpenginepowered.com" // wpengine environments added to internal links
               );

            $("a").each(function (e) {
                if (
                    !compareURL.test($(this).attr("href")) &&
                    !$(this).hasClass("internal-link")
                ) {
                    $(this).addClass("external-link");
                }
            });

            $("a").on("click", function (e) {
                let $el = $(e.currentTarget);

                if ($el.hasClass("external-link")) {
                    e.preventDefault();
                    let outLink = $el.attr("href");

                    $("#externalSW .btn-blue").attr("href", outLink);
                    $("#externalSW").modal("show");
                }
            });

            $("#externalSW .btn-blue").on("click", function () {
                $("#externalSW").modal("hide");
            });
        },

        shareSocialNetworks: () => {
            if (
                $("body").hasClass("single-post") ||
                $("body").hasClass("single-producto")
            ) {
                let urlActual = window.location.href;

                $("#facebook").click(function () {
                    window.open(
                        "https://www.facebook.com/sharer.php?u=" +
                            encodeURIComponent(urlActual),
                        "_blank"
                    );
                });

                // Función para compartir en Twitter
                $("#twitter").click(function () {
                    window.open(
                        "https://twitter.com/intent/tweet?url=" +
                            encodeURIComponent(urlActual),
                        "_blank"
                    );
                });

                // Función para compartir en Pinterest
                $("#pinterest").click(function () {
                    window.open(
                        "https://www.pinterest.com/pin/create/button/?url=" +
                            encodeURIComponent(urlActual),
                        "_blank"
                    );
                });

                // Función para compartir en WhatsApp
                $("#whatsapp").click(function () {
                    window.open(
                        "https://api.whatsapp.com/send?text=" +
                            encodeURIComponent(urlActual),
                        "_blank"
                    );
                });

                // Función para compartir por correo electrónico
                $("#email").click(function () {
                    if (
                        $("body").hasClass("single-post") &&
                        $("body").hasClass("brasil")
                    ) {
                        let titleName = $(
                            ".single-post.brasil .title-post"
                        ).text();
                        titleName = "Conheça sobre " + titleName;

                        window.open(
                            "mailto:?subject=" +
                                titleName +
                                "&body= Veja este artigo! " +
                                encodeURIComponent(urlActual),
                            "_blank"
                        );
                    } else if ($("body").hasClass("single-post")) {
                        let titleName = $(
                            ".single-post.brasil .title-post"
                        ).text();
                        titleName = "Conoce sobre " + titleName;

                        window.open(
                            "mailto:?subject=" +
                                titleName +
                                "&body= ¡Mira este artículo! " +
                                encodeURIComponent(urlActual),
                            "_blank"
                        );
                    } else if (
                        $("body").hasClass("single-producto") &&
                        $("body").hasClass("brasil")
                    ) {
                        let titleName = $(
                            ".single-producto.brasil .title-product"
                        ).text();
                        titleName = "Conheça nosso produto " + titleName;

                        window.open(
                            "mailto:?subject=" +
                                titleName +
                                "&body= Conheça este produto! " +
                                encodeURIComponent(urlActual),
                            "_blank"
                        );
                    } else if ($("body").hasClass("single-producto")) {
                        let titleName = $(
                            ".single-producto .title-product"
                        ).text();
                        titleName = "Conoce nuestro producto " + titleName;

                        window.open(
                            "mailto:?subject=" +
                                titleName +
                                "&body= ¡Mira este producto! " +
                                encodeURIComponent(urlActual),
                            "_blank"
                        );
                    }
                });
            }
        },
    };

    // Home scripts
    const $HomeScope = {
        init: function () {
            this.sliderHome({});
        },

        sliderHome: () => {
            if (!$("body").hasClass("brasil")) {
                $("main .sliders").slick({
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 4500,
                    easing: "ease",
                });
            } else {
                $("main .sliders").slick({
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 9500,
                    easing: "ease",
                });
            }
        },
    };

    // Styles Filter Product scripts
    const $ProductFilterStyles = {
        init: function () {
            this.stylesFilter();
            this.accordionFilter();
        },

        stylesFilter: () => {
            $(".styles .style-grid").on("click", (e) => {
                let $listProducts = $(".list-products");

                if ($listProducts.hasClass("rows")) {
                    $listProducts.removeClass("rows");
                }
            });

            $(".styles .style-rows").on("click", (e) => {
                let $listProducts = $(".list-products");

                if (!$listProducts.hasClass("rows")) {
                    $listProducts.addClass("rows");
                }
            });
        },

        accordionFilter: () => {
            $(".list-filter h4").on("click", (e) => {
                e.preventDefault();
                let $el = $(e.currentTarget);

                $el.toggleClass("active");
                $el.parent(".list-filter")
                    .find(".wrapper-filters")
                    .slideToggle("fast");
            });

            $(".list-filter h5, .list-filter h6").on("click", (e) => {
                e.preventDefault();
                let $el = $(e.currentTarget);

                $el.toggleClass("active");
                $el.next("ul").slideToggle("fast");
            });
            //It lets user to get filter selected open after he's redirect to product page
            if (
                $(
                    `[data-id='${window.localStorage.getItem(
                        "filterProductFromProduct"
                    )}']`
                ).length > 0
            ) {
                let element = $(
                    `[data-id='${window.localStorage.getItem(
                        "filterProductFromProduct"
                    )}']`
                );

                if (element.hasClass("list-lvl3")) {
                    element.parent(".level-3").parent(".2").slideToggle("fast");
                    element
                        .parent(".level-3")
                        .parent(".2")
                        .prev("h6")
                        .addClass("active");
                    element
                        .parent(".level-3")
                        .parent(".2")
                        .parent(".level-2.first-sublevel")
                        .parent("ul")
                        .slideToggle("fast");
                    element
                        .parent(".level-3")
                        .parent(".2")
                        .parent(".level-2.first-sublevel")
                        .parent("ul")
                        .prev("h5")
                        .addClass("active");
                    element
                        .parent(".level-3")
                        .parent(".2")
                        .parent(".level-2.first-sublevel")
                        .parent("ul")
                        .parent(".sub-filters")
                        .parent(".wrapper-filters")
                        .slideToggle("fast");
                    element
                        .parent(".level-3")
                        .parent(".2")
                        .parent(".level-2.first-sublevel")
                        .parent("ul")
                        .parent(".sub-filters")
                        .parent(".wrapper-filters")
                        .prev("h4")
                        .addClass("active");
                } else if (element.hasClass("list-lvl2")) {
                    if (
                        element
                            .parent(".level-2")
                            .parent("ul")
                            .hasClass("sub-filters")
                    ) {
                        element
                            .parent(".level-2")
                            .parent("ul.sub-filters")
                            .parent(".wrapper-filters")
                            .slideToggle("fast");
                        element
                            .parent(".level-2")
                            .parent("ul.sub-filters")
                            .parent(".wrapper-filters")
                            .prev("h4")
                            .addClass("active");
                    } else {
                        element
                            .parent(".level-2")
                            .parent("ul")
                            .slideToggle("fast");
                        element
                            .parent(".level-2")
                            .parent("ul")
                            .prev("h5")
                            .addClass("active");
                        element
                            .parent(".level-2")
                            .parent("ul")
                            .parent(".sub-filters")
                            .parent(".wrapper-filters")
                            .slideToggle("fast");
                    }
                }
            }
            $("h4.line-retail-title").on("click", () => {
                $(".list-filter.types").slideToggle(400);
                $(".list-filter.use-aplication").slideToggle(400);
            });

            /* $('h4.line-type-title').on('click', () => {
        if(!$('h4.line-use-title').hasClass('active')){
          $('.list-filter.retail').slideToggle(400);
        }
      });
      $('h4.line-use-title').on('click', () => {
        if(!$('h4.line-type-title').hasClass('active')){
          $('.list-filter.retail').slideToggle(400);
        }
      }); */
        },
    };

    // Filter Product scripts
    const $ProductFilter = {
        init: function () {
            this.ajaxFilter();
            this.preFilter();
            this.getFilters();
        },

        categoriesSelected: [],
        categoriesID: [],
        typesSelected: [],
        typesID: [],

        getFilters: () => {
            let filtersURL = window.location.search.substring(1),
                urlVariables = filtersURL.split("&"),
                elementsFilter = $(".list-filter").find(".list-item"),
                idSlug;

            for (iFilter = 0; iFilter < elementsFilter.length; iFilter++) {
                const eleFilter = elementsFilter[iFilter];

                for (
                    iVariable = 0;
                    iVariable < urlVariables.length;
                    iVariable++
                ) {
                    idSlug = urlVariables[iVariable];

                    if (eleFilter.dataset.id == idSlug) {
                        eleFilter.click();
                    }
                }
            }
        },

        ajaxFilter: () => {
            $(".list-item").on("click", function (e) {
                e.preventDefault();

                let catIndex,
                    typIndex,
                    filterCatIndex,
                    filterTypIndex,
                    filtersString;

                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");

                    catIndex = $ProductFilter.categoriesSelected.indexOf(
                        $(this).data("slug")
                    );
                    typIndex = $ProductFilter.typesSelected.indexOf(
                        $(this).data("slug")
                    );

                    filterCatIndex = $ProductFilter.categoriesID.indexOf(
                        $(this).data("id")
                    );
                    filterTypIndex = $ProductFilter.typesID.indexOf(
                        $(this).data("id")
                    );

                    if (catIndex > -1) {
                        $ProductFilter.categoriesSelected.splice(catIndex, 1);
                    }
                    if (typIndex > -1) {
                        $ProductFilter.typesSelected.splice(typIndex, 1);
                    }

                    if (filterCatIndex > -1) {
                        $ProductFilter.categoriesID.splice(filterCatIndex, 1);
                    }
                    if (filterTypIndex > -1) {
                        $ProductFilter.typesID.splice(filterTypIndex, 1);
                    }
                } else {
                    $(this).addClass("active");

                    if ($(this).parents("#filter-uses-title").length) {
                        $ProductFilter.categoriesSelected.push(
                            $(this).data("slug")
                        );
                        $ProductFilter.categoriesID.push($(this).data("id"));
                    } else if ($(this).parents("#filter-types-title").length) {
                        $ProductFilter.categoriesID.push($(this).data("id"));

                        $ProductFilter.typesSelected.push($(this).data("slug"));
                        $ProductFilter.typesID.push($(this).data("id"));
                    }
                }

                filtersString = $ProductFilter.categoriesID.join("&");
                history.pushState(
                    $ProductFilter.categoriesID,
                    "Productos",
                    "?" + filtersString
                );

                $.ajax({
                    type: "GET",
                    url: "/wp-admin/admin-ajax.php",
                    dataType: "html",
                    data: {
                        action: "filter_products",
                        category: $ProductFilter.categoriesSelected,
                        type: $ProductFilter.typesSelected,
                    },
                    success: function (res) {
                        HtmlSanitizer.AllowedAttributes["class"] = true;
                        let sanHTML = HtmlSanitizer.SanitizeHtml(res);
                        $(".section-product").empty().append(sanHTML);

                        // *************** Filter Pagination *******************
                        let numberOfItems = $(".list-products .product").length,
                            limitPerPage = 9,
                            totalPages = Math.ceil(
                                numberOfItems / limitPerPage
                            );

                        $(
                            ".list-products .product:gt(" +
                                (limitPerPage - 1) +
                                ")"
                        ).hide();

                        if (numberOfItems > 0) {
                            $(".filter-pagination ul").append(
                                '<li class="current-page active"><a href="javascript:void(0)">' +
                                    1 +
                                    "</a></li>"
                            );
                        } else {
                            $(
                                ".section-with-column.section-product .list-products"
                            ).append(
                                '<h2 class="not-results">No se han encontrado productos con el criterio de búsqueda</h2>'
                            );
                        }

                        for (let i = 2; i <= totalPages; i++) {
                            $(".filter-pagination ul").append(
                                '<li class="current-page"><a href="javascript:void(0)">' +
                                    i +
                                    "</a></li>"
                            );
                        }

                        if (numberOfItems > limitPerPage) {
                            if ($("body").hasClass("brasil")) {
                                $(".filter-pagination ul").append(
                                    '<li class="btn-next-page"><a href="javascript:void(0)" class="next page-numbers">Seguinte »</a></li>'
                                );
                            } else {
                                $(".filter-pagination ul").append(
                                    '<li class="btn-next-page"><a href="javascript:void(0)" class="next page-numbers">Siguiente »</a></li>'
                                );
                            }
                        }

                        $(".filter-pagination li.current-page").on(
                            "click",
                            function (e) {
                                let $el = $(e.currentTarget),
                                    currentPage = $el.index();

                                if (!$el.hasClass("active")) {
                                    $(".filter-pagination li").removeClass(
                                        "active"
                                    );
                                    $el.addClass("active");
                                    $(".list-products .product").hide();

                                    let grandTotal = limitPerPage * currentPage;

                                    for (
                                        let i = grandTotal - limitPerPage;
                                        i < grandTotal;
                                        i++
                                    ) {
                                        $(
                                            ".list-products .product:eq(" +
                                                i +
                                                ")"
                                        ).show();
                                    }
                                } else {
                                    return false;
                                }
                            }
                        );

                        $(".filter-pagination li").on("click", function (e) {
                            let $el = $(e.currentTarget),
                                currentPage = $el.index();

                            if (currentPage == 1) {
                                $(".btn-prev-page").hide();
                                $(".btn-next-page").show();
                            } else if (
                                currentPage > 1 &&
                                currentPage < totalPages
                            ) {
                                $(".btn-prev-page").show();
                                $(".btn-next-page").show();
                            } else if (currentPage == totalPages) {
                                $(".btn-prev-page").show();
                                $(".btn-next-page").hide();
                            }
                        });

                        $(".btn-next-page").on("click", function (e) {
                            let currentPage = $(
                                ".filter-pagination li.active"
                            ).index();

                            if (currentPage !== totalPages) {
                                currentPage++;
                                $(".filter-pagination li").removeClass(
                                    "active"
                                );
                                $(".list-products .product").hide();
                                let grandTotal = limitPerPage * currentPage;

                                for (
                                    var i = grandTotal - limitPerPage;
                                    i < grandTotal;
                                    i++
                                ) {
                                    $(
                                        ".list-products .product:eq(" + i + ")"
                                    ).show();
                                }

                                $(
                                    ".filter-pagination li.current-page:eq(" +
                                        (currentPage - 1) +
                                        ")"
                                ).addClass("active");
                            } else {
                                return false;
                            }
                        });

                        $(".btn-prev-page").on("click", function (e) {
                            let currentPage = $(
                                ".filter-pagination li.active"
                            ).index();

                            if (currentPage !== 1) {
                                currentPage--;
                                $(".filter-pagination li").removeClass(
                                    "active"
                                );
                                $(".list-products .product").hide();
                                let grandTotal = limitPerPage * currentPage;

                                for (
                                    var i = grandTotal - limitPerPage;
                                    i < grandTotal;
                                    i++
                                ) {
                                    $(
                                        ".list-products .product:eq(" + i + ")"
                                    ).show();
                                }

                                $(
                                    ".filter-pagination li.current-page:eq(" +
                                        (currentPage - 1) +
                                        ")"
                                ).addClass("active");
                            } else {
                                return false;
                            }
                        });
                        // ********************************************************
                    },
                });
            });
        },

        preFilter: () => {
            let localSlug = localStorage.getItem("filterProduct");
            let localSlugFromProduct = localStorage.getItem(
                "filterProductFromProduct"
            );

            if (localSlug !== null || localSlugFromProduct !== null) {
                $(".list-filter")
                    .find("[data-slug='" + localSlug + "']")
                    .click();
                localStorage.removeItem("filterProduct");
                localStorage.removeItem("filterProductFromProduct");
            }
        },
    };

    // Detail Product scripts
    const $ProductSingleScope = {
        init: function () {
            this.goToFilters();
            this.sliderColors();
            this.moreInformation();
            this.mixColorants();
        },

        goToFilters: () => {
            $(".list-item").on("click", function (e) {
                e.preventDefault();

                if (!$("body").hasClass("brasil")) {
                    window.location.href = "/productos?" + $(this).data("id");
                } else {
                    window.location.href = "/produtos?" + $(this).data("id");
                }

                window.localStorage.setItem(
                    "filterProductFromProduct",
                    $(this).data("id")
                );
            });
        },

        moreInformation: () => {
            $(".open-information").on("click", (e) => {
                let $el = $(e.currentTarget);

                $el.toggleClass("open-active");
                $el.next(".content").toggleClass("open-content");
            });
        },

        sliderColors: () => {
            if ($(".single-producto .list-colors").hasClass("slider-desktop")) {
                $(".single-producto .list-colors.slider-desktop").slick({
                    prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
                    nextArrow:
                        '<i class="fas fa-chevron-right slick-next"></i>',
                    easing: "ease",
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 7,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 550,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            } else {
                $(".single-producto .list-colors").slick({
                    prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
                    nextArrow:
                        '<i class="fas fa-chevron-right slick-next"></i>',
                    easing: "ease",
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 5000,
                            settings: "unslick",
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 7,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 550,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            }
        },

        mixColorants: () => {
            $(".list-colors.slider-desktop").on("click", "li", function (e) {
                e.preventDefault();
                let $el = $(e.currentTarget),
                    htmlColorant = "";

                $(".list-colors.slider-desktop li").removeClass("active");
                $el.addClass("active");

                $el.find(".base-corante").each(function () {
                    let titleColorant = $(this)
                            .find("[data-title-corante]")
                            .data("titleCorante"),
                        colorantHex = $(this)
                            .find("[data-hex-corante]")
                            .data("hexCorante"),
                        colorantUnit3L = $(this)
                            .find("[data-unit3l-corante]")
                            .data("unit3lCorante"),
                        colorant3L = $(this)
                            .find("[data-3l-corante]")
                            .data("3lCorante"),
                        colorantUnit15L = $(this)
                            .find("[data-unit15l-corante]")
                            .data("unit15lCorante"),
                        colorant15L = $(this)
                            .find("[data-15l-corante]")
                            .data("15lCorante");

                    if (
                        colorantHex === undefined ||
                        titleColorant === undefined
                    ) {
                        colorantHex = "#e7e7e7";
                        titleColorant = "";
                    }

                    htmlColorant +=
                        '<div class="block-colorant"><div class="info-formula"><div class="header header-3l">Formula para 3L</div><div class="header header-15l">Formula para 15L</div></div><div class="list-colorants"><div class="row-colorant"><div class="colorant-base"><svg version = "1.1" xmlns = "http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink" x = "0px" y = "0px" viewBox = "0 0 75.26 75.75" xml: space = "preserve"><path class="bg-colorant" style="fill:' +
                        colorantHex +
                        '" d="M40.22,75.07c-4.52,0-32.65-1.08-32.65-5.06V41.41L0.9,31.52V5.11c2.83-6.13,71.32-5.68,73.46,0v26.13 L67.7,41.41v28.61C67.7,73.9,44.01,75.07,40.22,75.07L40.22,75.07z M37.62,10.93c18.44,0,33.47-1.91,33.47-4.27 c0-2.35-15.02-4.26-33.47-4.26c-18.41,0-33.43,1.91-33.43,4.26C4.19,9.02,19.21,10.93,37.62,10.93L37.62,10.93z"/><g style="fill:#ffffff;opacity:0.25;"><path class="st2" d="M25.06,78.82c1.49,0,3.01,0,4.5,0V42.54c-1.53-0.03-3.04-0.08-4.5-0.13V78.82z"/><path class="st2" d="M31.82,78.82h5.17V42.64c-1.76,0-3.49-0.01-5.17-0.03V78.82z"/><path class="st2" d="M66.83,78.82h1.81V40.79c-0.58,0.09-1.19,0.18-1.81,0.27V78.82z"/><path class="st2" d="M63.18,78.82c0.84,0,1.68,0,2.48,0V41.21c-0.78,0.09-1.62,0.19-2.48,0.28V78.82z"/><path class="st2" d="M58.28,78.82c1.05,0,2.11,0,3.17,0V41.66c-1.04,0.08-2.09,0.18-3.17,0.26V78.82z"/><path class="st2" d="M52.73,78.82c1.29,0,2.54,0,3.85,0V42.04c-1.25,0.08-2.53,0.14-3.85,0.22V78.82z"/><path class="st2" d="M45.93,78.82c1.5,0,3.01,0,4.52,0V42.4c-1.48,0.06-2.98,0.09-4.52,0.13V78.82z"/><path class="st2" d="M38.5,78.82h5.17V42.58c-1.68,0.04-3.41,0.06-5.17,0.06V78.82z"/><path class="st2" d="M41.03,32.66c-5.95,0-42.95-0.58-42.95-2.71v2.52c0,0.71,4.06,1.24,9.69,1.64l3.27,7.26 c-0.41-0.05-0.81-0.1-1.21-0.14v37.59c0.82,0,1.65,0,2.49,0V41.86c0.57,0.06,1.15,0.12,1.74,0.18v36.78c1.05,0,2.11,0,3.14,0 v-36.5c0.56,0.05,1.14,0.09,1.72,0.14v36.36c1.28,0,2.55,0,3.83,0V42.29c-0.09-0.01-0.18-0.01-0.28-0.02l-3.65-7.6 c9.54,0.36,19.37,0.49,22.2,0.49c5,0,36.15-0.62,36.15-2.7v-2.52C77.18,32.02,46.03,32.66,41.03,32.66z M19.87,42.12 c-0.25-0.02-0.51-0.03-0.76-0.05l-3.62-7.54c0.33,0.01,0.66,0.03,1,0.04L19.87,42.12z"/></g></svg><span>' +
                        titleColorant +
                        '</span></div><div class="value value-3l">' +
                        colorant3L +
                        " " +
                        colorantUnit3L +
                        '</div><div class="value value-15l">' +
                        colorant15L +
                        " " +
                        colorantUnit15L +
                        "</div></div></div></div>";
                });

                $(".results-mix-colorants .containers-colorants")
                    .empty()
                    .html(htmlColorant);

                $("html, body").animate(
                    {
                        scrollTop:
                            $(".results-mix-colorants").offset().top - 200,
                    },
                    500
                );

                $(".results-mix-colorants").addClass("open");
            });
        },
    };

    // Detail Product Calculator scripts
    const $CalculatorProductScope = {
        init: function () {
            this.calculatorForm();
        },

        calculatorForm: () => {
            $("form.calculadora").submit(function () {
                var alto = $(this).find("#altura").val();
                var ancho = $(this).find("#ancho").val();

                var doors = {
                    simple: $(this).find("#d1").val(),
                    double: $(this).find("#d2").val(),
                    triple: $(this).find("#d3").val(),
                };

                var windows = {
                    simple: $(this).find("#w1").val(),
                    double: $(this).find("#w2").val(),
                    triple: $(this).find("#w3").val(),
                };

                var subTotal = parseFloat(alto) * parseFloat(ancho);

                if (!isNaN(subTotal)) {
                    resultD1 = doors.simple * 1.6;
                    resultD2 = doors.double * 3.2;
                    resultD3 = doors.triple * 4.8;

                    resultW1 = windows.simple * 0.66;
                    resultW2 = windows.double * 1.65;
                    resultW3 = windows.triple * 1.98;

                    var total =
                        new Number(
                            subTotal / parseFloat($(this).data("rendimiento"))
                        ).toFixed(1) * 2;

                    total =
                        total -
                        resultD1 -
                        resultD2 -
                        resultD3 -
                        resultW1 -
                        resultW2 -
                        resultW3;

                    if (total >= 0) {
                        if ($body.hasClass("brasil")) {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    "<span class='text-decoration'> " +
                                        total +
                                        "</span>" +
                                        " litros são necessários para 2 mãos"
                                );
                        } else {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    "Se necesitan <span class='text-decoration'> " +
                                        total +
                                        "</span>" +
                                        "  litros para 2 manos"
                                );
                        }
                    } else {
                        if ($body.hasClass("brasil")) {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    "Mais área é necessária para calcular o número de litros de tinta"
                                );
                        } else {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    "Se necesita más area para calcular la cantidad de litros de pintura"
                                );
                        }
                    }

                    $("#area").val(subTotal);
                } else {
                    $("#resultOperation").html(0);
                }
                return false;
            });
        },
    };

    // Detail Product Calculator CL scripts
    const $CalculatorProductChileScope = {
        init: function () {
            this.calculatorFormCl();
        },

        calculatorFormCl: () => {
            $("form.calculadora").submit(function () {
                var alto = $(this).find("#altura").val();
                var ancho = $(this).find("#ancho").val();

                var doors = {
                    simple: $(this).find("#d1").val(),
                    double: $(this).find("#d2").val(),
                    triple: $(this).find("#d3").val(),
                };

                var windows = {
                    simple: $(this).find("#w1").val(),
                    double: $(this).find("#w2").val(),
                    triple: $(this).find("#w3").val(),
                };

                var subTotal = parseFloat(alto) * parseFloat(ancho);

                if (!isNaN(subTotal)) {
                    resultD1 = doors.simple * 1.6;
                    resultD2 = doors.double * 3.2;
                    resultD3 = doors.triple * 4.8;

                    resultW1 = windows.simple * 0.66;
                    resultW2 = windows.double * 1.65;
                    resultW3 = windows.triple * 1.98;

                    var manos = parseFloat($(this).data("manos"));
                    var rendimiento = parseFloat($(this).data("rendimiento"));
                    var areaReal =
                        subTotal -
                        resultD1 -
                        resultD2 -
                        resultD3 -
                        resultW1 -
                        resultW2 -
                        resultW3;
                    var total = new Number(areaReal / rendimiento) * manos;
                    var totalStr = new String(total) + "";

                    totalStr = totalStr.split(".");
                    totalStr[1] > 3
                        ? (totalStr =
                              totalStr[0] + "," + totalStr[1].substring(0, 3))
                        : totalStr[0] + "," + totalStr[1];

                    if (total >= 0) {
                        if (total == 1) {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    `Se necesita <span class='text-decoration'> ${totalStr}</span>  galón para ${manos} manos`
                                );
                        } else {
                            $("#resultText")
                                .show()
                                .find("#resultOperation")
                                .html(
                                    `Se necesitan <span class='text-decoration'> ${totalStr}</span>  galones para ${manos} manos`
                                );
                        }
                    } else {
                        $("#resultText")
                            .show()
                            .find("#resultOperation")
                            .html(
                                "Se necesita más area para calcular la cantidad de galones de pintura"
                            );
                    }

                    $("#area").val(subTotal);
                } else {
                    $("#resultOperation").html(0);
                }
                return false;
            });
        },
    };

    // RetailLine  scripts
    const $RetailLineScope = {
        init: function () {
            //add new class to the body for Mexico retail line
            let linkRetail = document.getElementById("retailLineMX");

            if (linkRetail.classList.contains("active")) {
                $body.addClass("retailLineMX");
            }

            $(".retailLineMX .header-logo a").on("click", function (e) {
                e.preventDefault();
                return false;
            });
        },
    };

    // Line Retail Chile Products  scripts
    const $RetailLinechileScope = {
        init: function () {
            //add new class to the body for Chile retail line
            let linkRetail = document.getElementById("retailLineCL");

            if (linkRetail.classList.contains("active")) {
                $body.attr("id", "linea-retail-cl");
            }

            $("#linea-retail-cl .header-logo a").on("click", function (e) {
                e.preventDefault();
                return false;
            });
        },
    };

    // RexparProducts scripts
    const $RexparProductsScope = {
        init: function () {
            //add new class to the body for Mexico retail line
            let linkRetail = document.getElementById("RexparProducts");

            if (linkRetail.classList.contains("active")) {
                $body.addClass(" rexpar-products ");
                $body.attr("id", "rexpar-products");
            }
        },
    };

    // Xadrez Page scripts
    const $XadrezLadingScope = {
        init: function () {
            this.YtApi();
            this.TabLinks();
        },

        YtApi: () => {
            const landingXadrez = document.querySelector(
                "#single-product-xadrez-tinta-acrilica"
            );
            const sectionVideo = landingXadrez.querySelector(
                "#single-product__video"
            );
            const idVideo = sectionVideo.querySelector("#videoID");

            if (sectionVideo && idVideo) {
                var ytID = idVideo.textContent;
                var tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName("script")[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                var player;

                function onYouTubeIframeAPIReady() {
                    player = new YT.Player("player", {
                        videoId: ytID,
                        playerVars: {
                            autoplay: 1,
                            mute: 1,
                            controls: 0,
                            showinfo: 0,
                            rel: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            cc_load_policy: 0,
                            fs: 0,
                            end: 0,
                            enablejsapi: 1,
                        },
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: onPlayerStateChange,
                        },
                    });

                    function onPlayerReady(event) {
                        sectionVideo.addEventListener("click", function () {
                            event.target.playVideo();
                        });
                    }

                    function onPlayerStateChange(event) {
                        if (event.data === YT.PlayerState.ENDED) {
                            showReplayButton();
                        }
                    }
                }

                setTimeout(() => {
                    onYouTubeIframeAPIReady();
                }, 1600);
            }

            function showReplayButton() {
                $(".replay-video").show();

                $(".replay-video").on("click", (e) => {
                    player.seekTo(0);
                    player.playVideo();
                    $(".replay-video").delay(1500).hide();
                });
            }
        },

        TabLinks: () => {
            const landingXadrez = document.querySelector(
                "#single-product-xadrez-tinta-acrilica"
            );
            const singleProductTabs = landingXadrez.querySelector(
                "#single-product__tabs"
            );

            if (singleProductTabs) {
                const tabLinks = document.querySelectorAll(".tablinks");
                const tabContents = document.querySelectorAll(".tabcontent");

                function openTab(evt) {
                    const tabName =
                        evt.currentTarget.getAttribute("data-tabname");

                    tabContents.forEach((tab) => {
                        tab.style.display = "none";
                        tab.classList.add("d-none");
                    });

                    tabLinks.forEach((tab) => {
                        tab.classList.remove("active");
                    });

                    const tabContent = document.getElementById(tabName);
                    tabContent.style.display = "block";
                    tabContent.classList.remove("d-none");
                    evt.currentTarget.classList.add("active");
                }

                tabLinks.forEach((tab) => {
                    tab.addEventListener("click", openTab);
                });

                tabContents.forEach((tab) => {
                    tab.style.display = "none";
                    tab.classList.add("d-none");
                });

                const defaultTab = document.getElementById("inspirese");
                defaultTab.style.display = "block";
                defaultTab.classList.remove("d-none");
                tabLinks[0].classList.add("active");
            }
        },
    };

    // Color Page scripts
    const $ColorScope = {
        init: function () {
            // this.clickModal()
            this.modalOutSherwin();
        },

        clickModal: () => {
            $(".box-color").on("click", function () {
                var background = $(this).attr("data-modal-color");
                var codigoHexa = $(this).attr("codigo-hexa");
                $(".modal-content-color2").attr("style", background);
                var name = $(this).attr("title-name");
                $(".color-info .modal-color-name").text(name);
                $(".color-info .modal-color-hexa").text(codigoHexa);
            });
        },

        modalOutSherwin: () => {
            $("#paleta-sherwin-williams .wp-block-button__link").on(
                "click",
                function (e) {
                    e.preventDefault();
                    let $el = $(e.currentTarget),
                        outLink = $el.attr("href");

                    $("#outSW").modal("show");
                    $("#outSW .btn-blue").on("click", function (e) {
                        e.preventDefault();
                        window.open(outLink, "_blank");
                    });
                }
            );
        },
    };

    // Color-New scripts
    const $TrendsTabColorScope = {
        init: function () {
            this.tabColor();
        },

        tabColor: () => {
            // modificacion para el tab de colors-new
            const li1 = document.querySelectorAll(".li1");
            const li2 = document.querySelectorAll(".li2");
            const li3 = document.querySelectorAll(".li3");
            const li4 = document.querySelectorAll(".li4");
            const bloque1 = document.querySelectorAll(".bloque1");
            const bloque2 = document.querySelectorAll(".bloque2");
            const bloque3 = document.querySelectorAll(".bloque3");
            const bloque4 = document.querySelectorAll(".bloque4");
            const section = document.querySelectorAll(".contenedor");
            let contador = 1;
            // CLICK en li
            // TODOS .li quitar la clase activo
            // TODOS .bloque quitar la clase activo
            // .li con la posicion se añadimos la clase activo
            // .bloque con la posicion se añadimos la clase activo

            section.forEach((allsection, i) => {
                contador = contador + i;
                section[i].classList.add("contenedor" + contador);
            });

            // Recorriendo todos los LI
            li1.forEach((cadaLi, i) => {
                // Asignando un CLICK a CADALI
                li1[i].addEventListener("click", () => {
                    // Recorrer TODOS los .li
                    li1.forEach((cadaLi, i) => {
                        // Quitando la clase activo de cada li
                        li1[i].classList.remove("activo");
                        // Quitando la clase activo de cada bloque
                        bloque1[i].classList.remove("activo");
                    });

                    // En el li que hemos click le añadimos la clase activo
                    li1[i].classList.add("activo");
                    // En el bloque con la misma posición le añadimos la clase activo
                    bloque1[i].classList.add("activo");
                });
            });

            // Recorriendo todos los LI
            li2.forEach((cadaLi, i) => {
                // Asignando un CLICK a CADALI
                li2[i].addEventListener("click", () => {
                    // Recorrer TODOS los .li
                    li2.forEach((cadaLi, i) => {
                        // Quitando la clase activo de cada li
                        li2[i].classList.remove("activo");
                        // Quitando la clase activo de cada bloque
                        bloque2[i].classList.remove("activo");
                    });

                    // En el li que hemos click le añadimos la clase activo
                    li2[i].classList.add("activo");
                    // En el bloque con la misma posición le añadimos la clase activo
                    bloque2[i].classList.add("activo");
                });
            });

            // Recorriendo todos los LI
            li3.forEach((cadaLi, i) => {
                // Asignando un CLICK a CADALI
                li3[i].addEventListener("click", () => {
                    // Recorrer TODOS los .li
                    li3.forEach((cadaLi, i) => {
                        // Quitando la clase activo de cada li
                        li3[i].classList.remove("activo");
                        // Quitando la clase activo de cada bloque
                        bloque3[i].classList.remove("activo");
                    });

                    // En el li que hemos click le añadimos la clase activo
                    li3[i].classList.add("activo");
                    // En el bloque con la misma posición le añadimos la clase activo
                    bloque3[i].classList.add("activo");
                });
            });

            // Recorriendo todos los LI
            li4.forEach((cadaLi, i) => {
                // Asignando un CLICK a CADALI
                li4[i].addEventListener("click", () => {
                    // Recorrer TODOS los .li
                    li4.forEach((cadaLi, i) => {
                        // Quitando la clase activo de cada li
                        li4[i].classList.remove("activo");
                        // Quitando la clase activo de cada bloque
                        bloque4[i].classList.remove("activo");
                    });

                    // En el li que hemos click le añadimos la clase activo
                    li4[i].classList.add("activo");
                    // En el bloque con la misma posición le añadimos la clase activo
                    bloque4[i].classList.add("activo");
                });
            });

            const liRedirect = document.querySelectorAll(".li-redirect");

            // CLICK en li-redirect
            liRedirect.forEach((cadaLi, i) => {
                var url = "";
                url = urlredirect[i];

                // Asignando un CLICK a CADALI
                liRedirect[i].addEventListener("click", () => {
                    window.location.href = url;
                });
            });
        },
    };

    // Digital Color Wall scripts
    const $DigitalColorWallScope = {
        init: function () {
            this.loadScripts();
        },

        loadScripts: () => {
            window.PRISM.embed(document.getElementById("prism-embed-root"), {
                bindCallback: ({ publish, subscribe }) => {},
            });
        },
    };

    // Virtual Color Consultation scripts
    const $virtualColorConsultationScope = {
        init: function () {
            this.sliderCustomerOpinion();
            this.scrollToForm();
            this.formValidations();
        },

        sliderCustomerOpinion: () => {
            $(".info-customer-opinion").slick({
                prevArrow:
                    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style><i class="fas fa-chevron-left slick-prev"></i></button>',
                nextArrow:
                    '<button class="slick-next slick-arrow" aria-label="Next" type="button" style><i class="fas fa-chevron-right slick-next"></i></button>',
                dots: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 920,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        },

        scrollToForm: () => {
            $(".cta-form").on("click", function (e) {
                e.preventDefault();

                $("html, body").animate(
                    {
                        scrollTop: $(".form-section").offset().top - 30,
                    },
                    500
                );
            });
        },

        formValidations: () => {
            $(".form-section .wpcf7-tel").on("click", function (e) {
                $(this).val("+569 ");
            });

            //Disable copy, cut and paste function on Color Consultation form
            if ($body.hasClass("color-consultation")) {
                //no paste in input email of the form color consultation
                $(".email-input").on("paste", function (e) {
                    e.preventDefault();
                    return false;
                });
                //no copy in input email of the form color consultation
                $(".email-input").on("copy", function (e) {
                    e.preventDefault();
                    return false;
                });
                //no cut in input email of the form color consultation
                $(".email-input").on("cut", function (e) {
                    e.preventDefault();
                    return false;
                });
                //no click right in input email of the form color consultation
                $(".email-input").on("contextmenu", function (e) {
                    return false;
                });
            }

            //Input with class "nombre"
            $(".nombre-input").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /[^a-zA-Z\u00C0-\u017F\s]+$/
                    )
                )
                    return false;

                if ($(this).val().length > 50) return false;
            });

            //Input with class "apellido"
            $(".apellido-input").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /[^a-zA-Z\u00C0-\u017F\s]+$/
                    )
                )
                    return false;

                if ($(this).val().length > 50) return false;
            });

            //Input with class "telefono"
            $(".telefono-input").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (String.fromCharCode(charCode).match(/[^0-9]/)) return false;

                if ($(this).val().length > 14) return false;
            });

            //Input with class "email"
            $(".email-input").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                    )
                )
                    return false;

                if ($(this).val().length > 64) return false;
            });
        },
    };

    // A Sua Cor scripts
    const $ASuaCorScope = {
        init: function () {
            this.accordionRegulations();
        },

        accordionRegulations: () => {
            $(".open-regulations").on("click", (e) => {
                $(".regulations-list").toggleClass("open");
            });
        },
    };

    // ColorSnap Mobile scripts
    const $ColorSnapMobileScope = {
        init: function () {
            this.sliderCards();
        },

        sliderCards: () => {
            $(".slider-colorsnap").slick({
                prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
                nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
                dots: true,
                autoplay: true,
                autoplaySpeed: 15000,
                adaptiveHeight: true,
                easing: "ease",
            });
        },
    };

    // Color of the Year scripts
    const $ColorYearScope = {
        init: function () {
            this.ColorScroll();
            this.ColorGallery();
            this.ChangeTitle();
        },

        ColorScroll: () => {
            let scrollTop = $(window).scrollTop(),
                breadcrumbsOffset = $(".breadcrumbs").offset().top;

            if (breadcrumbsOffset < scrollTop) {
                $(".color-year").addClass("active-color");
            } else {
                $(".color-year").removeClass("active-color");
            }

            $(window).scroll(function () {
                let scrollTop = $(window).scrollTop(),
                    breadcrumbsOffset = $(".breadcrumbs").offset().top;

                if (breadcrumbsOffset < scrollTop) {
                    $(".color-year").addClass("active-color");
                } else {
                    $(".color-year").removeClass("active-color");
                }
            });

            $(".section-presentation .chip-color").click(() => {
                $("html, body").animate(
                    {
                        scrollTop: $(".environments").offset().top,
                    },
                    1000
                );

                return false;
            });
        },

        ColorGallery: () => {
            $(".btn-mobile .btn-color").on("click", (e) => {
                let $el = $(e.currentTarget),
                    dataBtn = $el.data("color"),
                    backgroundColor = $el.css("background-color");

                $(".btn-mobile .btn-color").addClass("clicked");
                $(".cards-color .card-color").removeClass("active");
                $(".cards-color .card-color").hide();

                setTimeout(() => {
                    $(".cards-color").css("background-color", backgroundColor);
                }, 1000);

                $(".cards-color .card-color").each(function () {
                    if ($(this).data("color") == dataBtn) {
                        $(this).show();
                        $(this).addClass("active");
                    }
                });
            });

            $(".cards-color .card-color").on("click", (e) => {
                var viewportWidth = $(window).width();
                if (viewportWidth > 991) {
                    let $el = $(e.currentTarget);

                    $(".cards-color .card-color").addClass("clicked");
                    $(".cards-color .card-color").removeClass("active");
                    $el.addClass("active");
                }
            });
        },

        ChangeTitle: () => {
            if ($body.hasClass("color-2023")) {
                let text_title = $("title").text();
                let new_title = text_title.replace(
                    "Color 2023",
                    "Color del Año 2023"
                );
                $("title").text(new_title);
            }
        },
    };

    // Map Page scripts
    const $MapsScope = {
        init: function () {
            this.customJS(), this.browserStores();
        },

        customJS: () => {
            if (!$("body").hasClass("brasil")) {
                $(".wpgmza-marker-listing-category-filter > span").html(
                    "Filtrar por:"
                );

                const checkMap = setInterval(() => {
                    if ($(".wpgmza_map .wpgmza-inner").length > 0) {
                        $(".wpgmza-inner .wpgmza-search .wpgmza-search").val(
                            "Buscar"
                        );
                        $(".wpgmza-inner .wpgmza-reset .wpgmza-reset").val(
                            "Restaurar"
                        );
                        clearInterval(checkMap);
                    }
                }, 500);

                const checkTable = setInterval(() => {
                    if (
                        $(".wpgmza_marker_holder .dataTables_wrapper").length >
                        0
                    ) {
                        $(".dataTable #wpgmza_map_list_title").html("Tiendas");
                        $(".dataTable #wpgmza_map_list_address").html(
                            "Dirección"
                        );

                        clearInterval(checkTable);
                    }
                }, 500);
            } else {
                $(".wpgmza-marker-listing-category-filter > span").html(
                    "Filtrar por:"
                );

                const checkMap = setInterval(() => {
                    if ($(".wpgmza_map").length > 0) {
                        $(".wpgmza-inner .wpgmza-search .wpgmza-search").val(
                            "Pesquisar"
                        );
                        $(".wpgmza-inner .wpgmza-reset .wpgmza-reset").val(
                            "Reinicialização"
                        );
                        clearInterval(checkMap);
                    }
                }, 500);

                const checkTable = setInterval(() => {
                    if (
                        $(".wpgmza_marker_holder .dataTables_wrapper").length >
                        0
                    ) {
                        $(".dataTables_filter label").prepend(
                            "<span>Encontre sua Loja</span>"
                        );
                        $(".dataTable #wpgmza_map_list_title").html("Loja");
                        $(".dataTable #wpgmza_map_list_address").html(
                            "Endereço"
                        );
                        clearInterval(checkTable);
                    }
                }, 500);
            }
        },

        browserStores: () => {
            if ($("body").hasClass("argentina")) {
                const clearInput = setInterval(() => {
                    if ($("#wpgmza_table_1_filter label input").length == 1) {
                        $("#wpgmza_table_1_filter label input").addClass(
                            "searchFinal"
                        );
                        $("#wpgmza_table_1_filter label input").hide();
                        $("#wpgmza_table_1_filter label").append(
                            "<input type='text' class='input-search'/>"
                        );
                        $("#wpgmza_table_1_filter").append(
                            "<button type='submit' class='buttonSearch' id='buttonSearch'> Buscar </button>"
                        );
                        clearInterval(clearInput);
                    }
                }, 500);

                const checkBoton = setInterval(() => {
                    if ($("#wpgmza_table_1_filter .buttonSearch").length == 1) {
                        const boton = document.getElementById("buttonSearch");

                        $(".input-search").keypress(function (event) {
                            var keycode = event.keyCode
                                ? event.keyCode
                                : event.which;
                            if (keycode == "13") {
                                $("#buttonSearch").click();
                            }
                        });

                        boton.addEventListener("click", (e) => {
                            const searchTerm = $(
                                "#wpgmza_table_1_filter label .input-search"
                            ).val();
                            $("#wpgmza_table_1_filter label .searchFinal").val(
                                searchTerm
                            );

                            const showInput = setInterval(() => {
                                if (
                                    $(
                                        "#wpgmza_table_1_filter label .searchFinal"
                                    ).val().length > 0
                                ) {
                                    $(
                                        "#wpgmza_table_1_filter label .input-search"
                                    ).remove();
                                    $(
                                        "#wpgmza_table_1_filter label .searchFinal"
                                    ).show();
                                    document
                                        .querySelector(".searchFinal")
                                        .dispatchEvent(new Event("input"));
                                    $("#buttonSearch").prop("disabled", true);
                                    clearInterval(showInput);
                                }
                            }, 500);

                            const resetInput = setInterval(() => {
                                if (
                                    $(
                                        "#wpgmza_table_1_filter label .searchFinal"
                                    ).val().length == 0
                                ) {
                                    $(
                                        "#wpgmza_table_1_filter label input"
                                    ).hide();

                                    if (
                                        $(
                                            "#wpgmza_table_1_filter label .input-search"
                                        ).length == 0
                                    ) {
                                        $(
                                            "#wpgmza_table_1_filter label"
                                        ).append(
                                            "<input type='text' class='input-search'/>"
                                        );
                                        $("#buttonSearch").removeAttr(
                                            "disabled"
                                        );
                                        $(".input-search").keypress(function (
                                            event
                                        ) {
                                            var keycode = event.keyCode
                                                ? event.keyCode
                                                : event.which;
                                            if (keycode == "13") {
                                                $("#buttonSearch").click();
                                            }
                                        });
                                    }
                                    clearInterval(resetInput);
                                }
                            }, 500);
                        });
                        clearInterval(checkBoton);
                    }
                }, 500);
            } else if ($("body").hasClass("brasil")) {
                const clearInput = setInterval(() => {
                    if ($("#wpgmza_table_4_filter label input").length == 1) {
                        $("#wpgmza_table_4_filter label input").addClass(
                            "searchFinal"
                        );
                        $("#wpgmza_table_4_filter label input").hide();
                        $("#wpgmza_table_4_filter label").append(
                            "<input type='text' class='input-search'/>"
                        );
                        $("#wpgmza_table_4_filter").append(
                            "<button type='submit' class='buttonSearch' id='buttonSearch'> Pesquisar </button>"
                        );
                        clearInterval(clearInput);
                    }
                }, 500);

                const checkBoton = setInterval(() => {
                    if ($("#wpgmza_table_4_filter .buttonSearch").length == 1) {
                        const boton = document.getElementById("buttonSearch");

                        $(".input-search").keypress(function (event) {
                            var keycode = event.keyCode
                                ? event.keyCode
                                : event.which;
                            if (keycode == "13") {
                                $("#buttonSearch").click();
                            }
                        });

                        boton.addEventListener("click", (e) => {
                            const searchTerm = $(
                                "#wpgmza_table_4_filter label .input-search"
                            ).val();
                            $("#wpgmza_table_4_filter label .searchFinal").val(
                                searchTerm
                            );

                            const showInput = setInterval(() => {
                                if (
                                    $(
                                        "#wpgmza_table_4_filter label .searchFinal"
                                    ).val().length > 0
                                ) {
                                    $(
                                        "#wpgmza_table_4_filter label .input-search"
                                    ).remove();
                                    $(
                                        "#wpgmza_table_4_filter label .searchFinal"
                                    ).show();
                                    document
                                        .querySelector(".searchFinal")
                                        .dispatchEvent(new Event("input"));
                                    $("#buttonSearch").prop("disabled", true);
                                    clearInterval(showInput);
                                }
                            }, 500);

                            const resetInput = setInterval(() => {
                                if (
                                    $(
                                        "#wpgmza_table_4_filter label .searchFinal"
                                    ).val().length == 0
                                ) {
                                    $(
                                        "#wpgmza_table_4_filter label input"
                                    ).hide();

                                    if (
                                        $(
                                            "#wpgmza_table_4_filter label .input-search"
                                        ).length == 0
                                    ) {
                                        $(
                                            "#wpgmza_table_4_filter label"
                                        ).append(
                                            "<input type='text' class='input-search'/>"
                                        );
                                        $("#buttonSearch").removeAttr(
                                            "disabled"
                                        );
                                        $(".input-search").keypress(function (
                                            event
                                        ) {
                                            var keycode = event.keyCode
                                                ? event.keyCode
                                                : event.which;
                                            if (keycode == "13") {
                                                $("#buttonSearch").click();
                                            }
                                        });
                                    }
                                    clearInterval(resetInput);
                                }
                            }, 500);
                        });
                        clearInterval(checkBoton);
                    }
                }, 500);
            }
        },
    };

    // Calendar Page scripts
    const $CalendarScope = {
        init: function () {
            this.eventsCalendar();
        },

        eventsCalendar: () => {
            $(".large-region").on("change", function () {
                let prov = $(".large-region")
                    .find(":selected")
                    .data("provincia");

                $(".card-body .event").show();
                $(".card-body .event").removeClass("show hidden");

                $(".small-region").prop("selectedIndex", 0);
                $(".small-region option").hide();
                $(".small-region option[data-localidad='" + prov + "']").show();
            });

            $(".small-region").on("change", function () {
                let locationData = $(".small-region")
                    .find(":selected")
                    .attr("value");

                $(".card-body .event").show();

                $(".card-body .event").removeClass("show hidden");

                $(".card-body .event").each(function () {
                    if ($(this).data("event-location") != locationData) {
                        $(this).hide().toggleClass("hidden");
                    } else {
                        $(this).toggleClass("show");
                    }
                });
            });
        },
    };

    // SW Pro scripts
    const $SwProScope = {
        init: function () {
            this.anchorsMenu();
            this.sliderSwPro();
            this.getCodeFormRegister();
            this.initSelect2();
        },

        anchorsMenu: () => {
            let hash = location.hash.replace(/^#/, "");

            if (hash) {
                $('.nav-tabs a[href="#' + hash + '"]').tab("show");
            }

            $(".nav-tabs a").on("shown.bs.tab", function (e) {
                window.location.hash = e.target.hash;
            });
        },

        sliderSwPro: () => {
            if ($("body").hasClass("chile")) {
                var $this = $(".sliders");
                var slideCount = $this.find(".slider-content").length;
                var options = {
                    autoplay: true,
                    autoplaySpeed: 9500,
                    easing: "ease",
                };

                // If there's only one slide, hide the dots
                if (slideCount <= 1) {
                    options.dots = false;
                } else {
                    options.dots = true;
                }

                $this.slick(options);
            }
        },

        getCodeFormRegister: () => {
            $(".telefono-form-chile").each(function () {
                // if ($(this).val().length === 0) {
                //     $(this).val('+56 ');
                // }
            });

            $('.wpcf7-form-control-wrap[data-name="swpro-tel"]').addClass(
                "tel-base"
            );

            $(".telefono-form-chile")
                // .keydown(function (e) {
                //     var charCode = e.which ? e.which : e.keyCode;
                //     var val = $(this).val();

                //     // Previene eliminar los primeros dos caracteres "56"
                //     if (
                //         val.length <= 5 &&
                //         (charCode === 8 || charCode === 46)
                //     ) {
                //         e.preventDefault();
                //     }
                // })
                .keypress(function (e) {
                    var charCode = e.which ? e.which : e.keyCode;

                    // Permite solo números
                    if (String.fromCharCode(charCode).match(/[^0-9]/))
                        return false;

                    // Limita la longitud a 8 caracteres
                    if ($(this).val().length > 7) return false;
                })
                .bind("copy paste", "input", function (e) {
                    e.preventDefault();
                });

            document.addEventListener(
                "wpcf7mailsent",
                function (e) {
                    var modal = document.getElementById("modalPro"),
                        span = document.getElementsByClassName("close")[0],
                        code_section = document.getElementById("custom_code"),
                        button_download =
                            document.getElementById("download-code");
                    span.onclick = function () {
                        modal.style.display = "none";
                        location.reload(true);
                    };

                    window.onclick = function (event) {
                        if (event.target == modal) {
                            modal.style.display = "none";
                        }
                    };
                    $.post({
                        dataType: "json",
                        // url: "/wp-admin/admin-ajax.php",
                        url: SITE_API.api_url,
                        data: {
                            action: "get_promo_code",
                            nonce: SITE_API.api_nonce,
                        },
                        success: function (response) {
                            code_section.innerText = response.code;
                            modal.style.display = "flex";
                            button_download.addEventListener("click", () => {
                                const code_print =
                                    document.querySelector(".code_print");
                                html2canvas(code_print).then((canvas) => {
                                    // Crear un enlace para descargar la imagen
                                    const link = document.createElement("a");
                                    link.href = canvas.toDataURL("image/png");
                                    link.download = "SW-CUPON.png";
                                    link.click();
                                });
                            });
                        },
                    });
                },
                false
            );

            /**
             * Disable WPCF7 button while it's submitting
             * Stops duplicate enquiries coming through
             */
            document.addEventListener(
                "wpcf7submit",
                function (event) {
                    let button = $(".wpcf7-submit[disabled]");
                    let old_value = button.attr("data-value");

                    button.prop("disabled", false);
                    button.val(old_value);
                },
                false
            );

            $("form.wpcf7-form").on("submit", function () {
                let form = $(this);
                let button = form.find("input[type=submit]");
                let current_val = button.val();

                button.attr("data-value", current_val);
                button.prop("disabled", true);
                button.val("Enviando...");
            });
        },

        initSelect2: () => {
            $(".select-comuna-form").select2({
                language: {
                    noResults: function () {
                        return "No hay resultados";
                    },
                    searching: function () {
                        return "Buscando..";
                    },
                },
            });
        },
    };

    // Services scripts
    const $ServicesScope = {
        init: function () {
            this.toolHelper({});
        },

        toolHelper: () => {
            $(".tools .choice").on("change", (e) => {
                let $el = $(e.currentTarget);

                $el.addClass("empty");
            });
        },
    };

    // Single Color Scripts
    const $SingleColorScope = {
      init: function () {
        jQuery(".colors-wrapper").each(function () {
          let paletteId = jQuery(this).data("palette");
          $SingleColorScope.getTotalColors(paletteId); // Get total colors and then initialize
        });

        // Delegación de eventos para evitar duplicados
        jQuery(document).on("click", ".pagination-link", function (e) {
          e.preventDefault();
          let selectedPage = jQuery(this).data("page");
          let selectedPalette = jQuery(this).data("palette");
          $SingleColorScope.loadColorsPage(selectedPalette, selectedPage);

          const colorsContainer = document.getElementById('colors-container-' + selectedPalette);
          if (window.innerWidth <= 768) {
            colorsContainer.scrollIntoView({ behavior: "smooth" });
            }
        });
      },

      getTotalColors: function (paletteId) {
        const postId =
          jQuery(`#colors-container-${paletteId}`)
            .closest("[data-post-id]")
            .data("post-id") || 0;
        // Make an AJAX call to get the total number of colors for the palette
        jQuery.ajax({
          url: SITE_API.api_url,
          type: "POST",
          data: {
            action: "get_total_colors",
            palette_id: paletteId,
            post_id: postId,
          },
          success: function (response) {
            let totalColors = parseInt(response); 
            // Check if the response is a valid number
            if (isNaN(totalColors)) {
              console.error("Invalid total colors received:", response);
              totalColors = 0;
            }

            let colorsPerPage = 12;
            $SingleColorScope.initPalette(
              paletteId,
              totalColors,
              colorsPerPage
            );
          },
          error: function (xhr, status, error) {
            console.error("Error getting total colors:", status, error);
            let colorsPerPage = 12;
            $SingleColorScope.initPalette(paletteId, 0, colorsPerPage); // Initialize with 0 colors
          },
        });
      },

      loadColorsPage: (paletteId, page) => {
        const postId =
          jQuery(`#colors-container-${paletteId}`)
            .closest("[data-post-id]")
            .data("post-id") || 0;

        jQuery.ajax({
          url: SITE_API.api_url,
          type: "POST",
          data: {
            action: "load_palette_colors",
            palette_id: paletteId,
            page: page,
            post_id: postId,
          },
          beforeSend: function () {
            // Show a loading message while waiting for the AJAX response
            jQuery(`#colors-container-${paletteId} .colors-list`).html(
              `<div class="colors-wrapper__loader"><span>Loading colors...</span></div>`
            );
          },
          success: function (response) {
            // Update only the colors-list div with the new colors
            jQuery(`#colors-container-${paletteId} .colors-list`).html(
              response
            );
          },
          error: function (xhr, status, error) {
            console.error("AJAX Error:", status, error);
            // Display an error message if the AJAX request fails
            jQuery(`#colors-container-${paletteId} .colors-list`).html(
              `<div class="colors-wrapper__error"><p>Error loading colors...</p></div>`
            );
          },
        });
      },

      // Function to generate the pagination links
      generatePagination: (paletteId, postId, totalColors, colorsPerPage) => {
        const totalPages = Math.ceil(totalColors / colorsPerPage);
        let paginationHtml = '<div class="pagination">';
        for (let i = 1; i <= totalPages; i++) {
          paginationHtml += `<a href="#" class="pagination-link" data-page="${i}" data-palette="${paletteId}">${i}</a>`;
        }
        paginationHtml += "</div>";
        // Set the pagination HTML inside the pagination-container div
        jQuery(`#colors-container-${paletteId} .pagination-container`).html(
          paginationHtml
        );

        // Add click event listener to the pagination links
        jQuery(`#colors-container-${paletteId} .pagination-link`).on(
          "click",
          function (e) {
            e.preventDefault();
            const page = jQuery(this).data("page");
            // Call the loadColorsPage function to load the colors for the selected page
            $SingleColorScope.loadColorsPage(paletteId, page);

            // Remove the 'active' class from all pagination links
            jQuery(
              `#colors-container-${paletteId} .pagination-link`
            ).removeClass("active");
            // Add the 'active' class to the clicked pagination link
            jQuery(this).addClass("active");
          }
        );
      },

      // Initialization function (call this when the page loads)
      initPalette: (paletteId, totalColors, colorsPerPage) => {
        // Get the post ID
        const postId =
          jQuery(`#colors-container-${paletteId}`)
            .closest("[data-post-id]")
            .data("post-id") || 0;


        if (totalColors > 12){
            // Generate the pagination
            $SingleColorScope.generatePagination(
                paletteId,
                postId,
                totalColors,
                colorsPerPage
            );
        }

        // Load the first page of colors
        $SingleColorScope.loadColorsPage(paletteId, 1);

        // Add the 'active' class to the first pagination link
        jQuery(
          `#colors-container-${paletteId} .pagination-link[data-page="1"]`
        ).addClass("active");
      },
    };

    // Our History scripts
    const $OurHistoryScope = {
        init: function () {
            this.openImageModal();
        },

        // Modal Sites
        openImageModal: () => {
            $(".timeline .image img").on("click", (e) => {
                e.preventDefault();
                let $el = $(e.currentTarget);

                $("#swModalImage .modal-body").empty();
                $el.clone().appendTo("#swModalImage .modal-body");
                $("#swModalImage").modal("show");
            });
        },
    };

    // Register Form scripts
    const $RegisterScope = {
        init: function () {
            this.optionalField();
            this.validationInputs();
        },

        // Conditional Field in Form
        optionalField: () => {
            $(".curso .first input").change(function () {
                if (this.checked) {
                    $(".optional-field").hide();
                    $(".optional-field .last input").prop("checked", true);
                } else {
                    $(".optional-field").show();
                    $(".optional-field .last input").prop("checked", false);
                }
            });

            $(".curso .last input").change(function () {
                if (this.checked) {
                    $(".optional-field").show();
                    $(".optional-field .last input").prop("checked", false);
                }
            });
        },

        //Validation inputs form
        validationInputs: () => {
            //Input with class "nombre"
            $(".nombre-form").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /[^a-zA-Z\u00C0-\u017F\s]+$/
                    )
                )
                    return false;
            });

            //Input with class "apellido"
            $(".apellido-form").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /[^a-zA-Z\u00C0-\u017F\s]+$/
                    )
                )
                    return false;
            });

            //Input with class "telefono"
            $(".telefono-form").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (String.fromCharCode(charCode).match(/[^0-9]/)) return false;

                if ($(this).val().length > 14) return false;
            });

            //Input with class "email"
            $(".email-form").keypress(function (e) {
                var charCode = e.which ? e.which : event.keyCode;
                if (
                    String.fromCharCode(charCode).match(
                        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                    )
                )
                    return false;

                if ($(this).val().length > 64) return false;
            });
        },
    };

    // Triggers
    $GeneralScope.init();

    const $body = $("body");

    // Home Scripts
    if ($body.hasClass("home")) {
        $HomeScope.init();
    }

    // Products Filters Styles Scripts
    if (
        $body.hasClass("productos") ||
        $body.hasClass("produtos") ||
        $body.hasClass("single-producto") ||
        $body.hasClass("single-produto")
    ) {
        $ProductFilterStyles.init();
    }

    // Products Filters Functionality Scripts
    if ($body.hasClass("productos") || $body.hasClass("produtos")) {
        $ProductFilter.init();
    }

    // Product Scripts
    if ($body.hasClass("single-producto") || $body.hasClass("single-produto")) {
        $ProductSingleScope.init();
    }

    // Calculator Product Scripts
    if ($body.hasClass("single-producto") && !$body.hasClass("chile")) {
        $CalculatorProductScope.init();
    }

    // Calculator Product Chile Scripts
    if ($body.hasClass("single-producto") && $body.hasClass("chile")) {
        $CalculatorProductChileScope.init();
    }

    // Mexico Retail Line Scripts
    if ($body.hasClass("productos mexico")) {
        $RetailLineScope.init();
    }

    // Argentina products Rexpar Scripts
    if ($body.hasClass("productos argentina")) {
        $RexparProductsScope.init();
    }

    // Chile Reatail Line Scripts
    if ($body.hasClass("productos chile")) {
        $RetailLinechileScope.init();
    }

    // Xadrez Page Scripts
    if ($body.hasClass("xadrez-tinta-acrilica")) {
        $XadrezLadingScope.init();
    }

    // Colors Scripts
    if ($body.hasClass("colores")) {
        $ColorScope.init();
    }

    // Colors-New Scripts
    if ($body.hasClass("cores")) {
        $TrendsTabColorScope.init();
    }

    // Digital Color Wall Scripts
    if (
        $body.hasClass("digital-color-wall") ||
        $body.hasClass("colorsnap-visualizer-web")
    ) {
        $DigitalColorWallScope.init();
    }

    // Virtual Color Consultation Scripts
    if ($body.hasClass("color-consultation")) {
        $virtualColorConsultationScope.init();
    }

    // A Sua Cor Scripts
    if ($body.hasClass("a-sua-cor")) {
        $ASuaCorScope.init();
    }

    // ColorSnap Mobile Scripts
    if ($body.hasClass("colorsnap-visualizer-app")) {
        $ColorSnapMobileScope.init();
    }

    // Color of the Year Scripts
    if (
        $body.hasClass("color-2023") ||
        $body.hasClass("cor-do-ano-2023") ||
        $body.hasClass("color-2024") ||
        $body.hasClass("cor-do-ano-2024") ||
        $body.hasClass("capsula-de-cores-do-ano-2025") ||
        $body.hasClass("color-2025") ||
        $body.hasClass("cor-do-ano-2025") ||
        $body.hasClass("capsula-de-cores-do-ano-2025")
    ) {
        $ColorYearScope.init();
    }

    // Maps Scripts
    if ($body.attr("id") == "wpgomaps") {
        $MapsScope.init();
    }

    // Calendar Scripts
    if ($body.hasClass("calendario")) {
        $CalendarScope.init();
    }

    // SW Pro Scripts
    if (
        $body.hasClass("sw-pro") ||
        $body.hasClass("sw-pro-pintor") ||
        $body.hasClass("sherwin-williams-pro") ||
        $body.hasClass("sw-pro-app")
    ) {
        $SwProScope.init();
    }

    // Services Scripts
    if ($body.hasClass("servicio-tecnico")) {
        $ServicesScope.init();
    }

    // Single Color Scripts
    if ($body.hasClass("single-color-collection")) {
        $SingleColorScope.init();
    }

    // Our History Scripts
    if (
        ($body.hasClass("nuestra-historia") &&
            $body.hasClass("conozca-sherwin")) ||
        ($body.hasClass("nossa-historia") &&
            $body.hasClass("conheca-a-sherwin"))
    ) {
        $OurHistoryScope.init();
    }

    // Register Scripts
    if (
        $body.hasClass("registro") ||
        $body.hasClass("contactenos") ||
        $body.hasClass("contacto")
    ) {
        $RegisterScope.init();
    }
});
